import { TBillingInterval } from "@/types/app";
import formatDate from "@/utils/formatDate";
import { formatPriceOrNA } from "@/utils/formatPriceOrNA";
import formatTemplateString from "@/utils/formatTemplateString";
import { getBillingLabel } from "@/utils/getBillingLabel";

const PLAN_END_DATE_FORMAT = "MMM d, yyyy";

export type TUnusedDaysCredit = {
  label: string;
  value: string;
};

export const formatPlanEndDate = (unixSeconds?: number) =>
  unixSeconds ? formatDate(unixSeconds, PLAN_END_DATE_FORMAT) : undefined;

export const formatEndsOn = (template: string, unixSeconds?: number) => {
  const endDate = formatPlanEndDate(unixSeconds);
  return endDate ? formatTemplateString(template, endDate) : undefined;
};

export const formatRenewalAmount = (
  amount: number | undefined,
  currency: string,
) =>
  formatPriceOrNA(amount, currency, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

export const formatRenewNote = (
  template: string,
  amount: number | undefined,
  currency: string,
  interval: TBillingInterval,
) =>
  formatTemplateString(
    template,
    formatRenewalAmount(amount, currency),
    getBillingLabel(interval),
  );

export const getUnusedDaysCredit = (
  text: TUnusedDaysCredit,
  unusedDays?: number,
): TUnusedDaysCredit | undefined =>
  unusedDays
    ? {
        label: formatTemplateString(text.label, String(unusedDays)),
        value: text.value,
      }
    : undefined;
